<!--
   Created by qing on 2020/12/23
   Des: 
-->
<template>

  <van-popup
    class="print-result-popup"
    v-model="visibleInfo.visible"
    :overlay="false"
    :style="{ height: '100%', width: '100%' }"
    @close="beforeClose"
    position="right">
    <div class="excel-print-result-page">
      <header>
        <span>{{pageTitle}}</span>
      </header>
      <div class="result-container" v-if="type === 'PRINT_RESULT' && exportInfo">
        <div
          class="result-container-wrapper"
          v-if="exportInfo.exportStage === 'EXPORT_PREPARED'">
          <h2>打印排队中，请等待...</h2>
        </div>
        <div
          class="result-container-wrapper"
          v-if="exportInfo.exportStage === 'EXPORTING'">
          <h2>正在生成打印中...</h2>
          <el-progress
            style="width: 100%;"
            :text-inside="true"
            :stroke-width="24"
            :percentage="percentage"
            status="success">
          </el-progress>
          <p class="tips">请勿关闭此页面</p>
        </div>
        <div
          class="result-container-wrapper"
          v-if="exportInfo.exportStage === 'EXPORT_COMPLETE'">
          <input
            style="opacity: 0"
            type="text"
            ref="copyInput">
          <h2>生成成功...</h2>
          <i class="iconfont icon-Excel"></i>
          <el-button
            type="primary"
            size="small"
            @click="downloadExcel">
            点击下载
          </el-button>
          <template v-if="isIOS || (isAndroid && isSmallProgram)">
            <p>
              请您复制下载链接，用<span v-if="isIOS">Safari</span>浏览器打开下载
            </p>
            <van-button
              type="primary"
              size="small"
              @click="copyUrl">
              复制链接
            </van-button>
          </template>
        </div>
        <div
          class="result-container-wrapper"
          v-if="exportInfo.exportStage === 'EXPORT_FAILED'">
          <h2>打印失败，请联系管理员。</h2>
        </div>
        <div
          class="result-container-wrapper"
          v-if="exportInfo.exportStage === 'OUT_TIME'">
          <h2>排队人数多，后续通过消息下发，请注意查看消息。</h2>
        </div>
      </div>
      <div class="result-container" v-else-if="type === 'PRINT' || type === 'EXPORT'">
        <input
          style="opacity: 0"
          type="text"
          ref="copyInput">
        <div class="result-container-wrapper">
          <h2>导出成功...</h2>
          <i class="iconfont icon-Excel"></i>
          <el-button
            type="primary"
            size="small"
            @click="downloadExcel">
            点击下载
          </el-button>
          <template v-if="isIOS">
            <p>
              请您复制下载链接，用Safari浏览器打开下载
            </p>
            <van-button
              type="primary"
              @click="copyUrl">
              复制链接
            </van-button>
          </template>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
  export default {
    props: {
      stackList: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {

        visibleInfo: {
          visible: false
        },
        type: '',
        downloadUrl: '',
        exportId: '',
        companyId: '',
        pageTitle: '',
        exportStageMap: {
          'EXPORT_PREPARED': '导出准备完成',
          'EXPORTING': '导出中',
          'EXPORT_COMPLETE': '导出完成',
          'EXPORT_FAILED': '导出失败',
          'OUT_TIME': '超时'
        },
        exportInfo: null,
        percentage: 0,
        timer: null,
      }
    },
    created() {
    },
    computed: {
      isIOS() {
        console.log('ua', window.isIOS, window.ua)
        return window.isIOS
      },
      isAndroid() {
        return window.isAndroid
      },
      isSmallProgram() {
        console.log('isSmallProgram', this.$store.getters.env)
        return !this.$store.getters.env || this.$store.getters.env === 'smallProgram'
      }
    },
    methods: {
      open({type, exportId, companyId, pageTitle}) {
        this.type = type
        this.exportId = exportId
        this.companyId = companyId
        this.pageTitle = pageTitle
        if (this.exportId && this.companyId) {
          this.fetchResult()
        }
        this.stackList.push(this.visibleInfo)
        this.visibleInfo.visible = true
      },
      beforeClose() {
        clearTimeout(this.timer)
      },
      fetchResult() {
        this.$store.dispatch('actionFetchExcelPrintProgressQuery', {
          companyId: this.companyId,
          exportId: this.exportId
        })
          .then(res => {
            if (res.exportStage === 'EXPORTING' ||
              res.exportStage === 'EXPORT_PREPARED') {
              this.timer = setTimeout(() => {
                this.fetchResult()
              }, 2000)

              if (this.percentage < 90) {
                this.percentage += 10
              }
            } else if (res.exportStage === 'EXPORT_COMPLETE' ||
              res.exportStage === 'EXPORT_FAILED' ||
              res.exportStage === 'OUT_TIME') {
              clearTimeout(this.timer)
              this.percentage = 100
            }
            this.exportInfo = res
          })
          .catch(console.error)
      },
      downloadExcel() {
        let link = document.createElement('a')
        link.style.display = 'none'
        if (this.type === 'PRINT_RESULT') {
          link.href = this.exportInfo.fileKey
        } else if (this.type === 'PRINT' || this.type === 'EXPORT') {
          link.href = this.downloadUrl
        }
        document.body.appendChild(link)
        link.click()
      },
      copyUrl() {
        let link = ''
        if (this.type === 'PRINT_RESULT') {
          link = this.exportInfo.fileKey
        } else if (this.type === 'PRINT' || this.type === 'EXPORT') {
          link = this.downloadUrl
        }
        const inputObj = this.$refs.copyInput
        inputObj.setAttribute('value', link)
        inputObj.setAttribute("readonly", "readonly")
        inputObj.select()
        const result = window.document.execCommand(`copy`, false, undefined)
        if (result) {
          this.$toast.success(`复制成功`)
        } else {
          this.$toast.fail(`复制失败`)
        }
      }
    }
  }
</script>

<style lang="less">

  .print-result-popup {

    .excel-print-result-page {
      height: 100%;
      position: relative;
      padding: 0;

      > header {
        position: relative;
        top: 0;
        left: 0;
        right: 0;
        font-size: 13px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .15);
        padding: 0 20px;
        z-index: 10;
        line-height: 50px;
        height: 50px;
        background: #fff 0 0 no-repeat padding-box;
        box-shadow: 0 1px 3px rgba(0, 0, 0, .16);
        display: flex;
        justify-content: space-between;
        align-items: center;

        > span {
          font-size: 17px;
          font-weight: 700;
        }
      }

      .result-container {
        position: relative;
        left: 0;
        right: 0;
        top: 0;
        height: calc(100% - 50px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .result-container-wrapper {
          min-width: 300px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;

          h2 {
            margin-bottom: 30px;
          }

          i {
            color: #19be6b;
            font-size: 40px;
            margin-bottom: 40px;
          }

          .tips {
            font-size: 13px;
            color: #5d616f;
            margin-top: 40px;
          }

          p {
            margin: 20px 0;
            font-size: 13px;
            color: #5d616f;
          }

          .van-button {
            width: 100px;
          }
        }
      }
    }
  }
</style>